import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

import { preferencesSuccess } from "../../User/redux/user.actions"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getApiKeysRequest: ["payload"],
  getApiKeysSuccess: ["payload"],
  getApiKeysFailure: ["payload"],

  getEventsRequest: ["payload"],
  getEventsSuccess: ["payload"],
  getEventsFailure: ["payload"],

  getEventRequest: ["payload"],
  getEventSuccess: ["payload"],
  getEventFailure: ["payload"],

  resendEventRequest: ["payload"],
  resendEventSuccess: ["payload"],
  resendEventFailure: ["payload"],

  generateApiKeyRequest: ["payload"],
  generateApiKeySuccess: ["payload"],
  generateApiKeyFailure: ["payload"],

  regenerateApiKeyRequest: ["payload"],
  regenerateApiKeySuccess: ["payload"],
  regenerateApiKeyFailure: ["payload"],

  getEndpointsRequest: ["payload"],
  getEndpointsSuccess: ["payload"],
  getEndpointsFailure: ["payload"],

  getEndpointRequest: ["payload"],
  getEndpointSuccess: ["payload"],
  getEndpointFailure: ["payload"],

  changeEndpointStatusRequest: ["payload"],
  changeEndpointStatusSuccess: ["payload"],
  changeEndpointStatusFailure: ["payload"],

  deleteEndpointRequest: ["payload"],
  deleteEndpointSuccess: ["payload"],
  deleteEndpointFailure: ["payload"],

  addEndpointRequest: ["payload"],
  addEndpointSuccess: ["payload"],
  addEndpointFailure: ["payload"],

  addTypesRequest: ["payload"],
  addTypesSuccess: ["payload"],
  addTypesFailure: ["payload"],

  publicApiSetProp: ["key", "value"],

  requestResultReset: null
})

export const PublicApiTypes = Types
export default Creators

export const INITIAL_STATE = Immutable({
  apiKeys: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },
  apiKeysFetching: true,
  apiKeysError: null,

  //webhooks data
  endpoints: {
    count: 0,
    results: []
  },
  events: {
    count: 0,
    results: []
  },
  requestResult: null,

  webhooksFetching: false,

  endpointData: null,

  filtersEvents: {
    event_name: [],
    source_id: [],
    created_timestamp: null,
    exclude_fields: []
  },
  filterWebhookAttempts: "all",
  eventData: null
})

const getApiKeysRequest = (state) => state.merge({ apiKeysFetching: true })
const getApiKeysSuccess = (state, { payload }) => {
  return state.merge({
    apiKeys: payload || {
      count: 0,
      next: null,
      previous: null,
      results: []
    },
    apiKeysFetching: false
  })
}
const getApiKeysFailure = (state, errors) => {
  return state.merge({ apiKeysError: "Failed to load api keys" })
}

const getEventsRequest = (state) => state.merge({ webhooksFetching: true })
const getEventsSuccess = (state, { payload: data }) => {
  return state.merge({ events: data, webhooksFetching: false })
}
const getEventsFailure = (state) => state.merge({ webhooksFetching: false })

const getEventRequest = (state) => state.merge({ webhooksFetching: true })
const getEventSuccess = (state, { payload: data }) => {
  return state.merge({ eventData: data, webhooksFetching: false })
}
const getEventFailure = (state) => state.merge({ webhooksFetching: false })

const generateApiKeyRequest = (state) => state
const generateApiKeySuccess = (state, { payload }) => state
const generateApiKeyFailure = (state, errors) => state

const regenerateApiKeyRequest = (state) => state
const regenerateApiKeySuccess = (state, { payload }) => state
const regenerateApiKeyFailure = (state, errors) => state

const getEndpointsRequest = (state) => state.merge({ webhooksFetching: true })
const getEndpointsSuccess = (state, { payload: data }) =>
  state.merge({ webhooksFetching: false, endpoints: data })
const getEndpointsFailure = (state) => state.merge({ webhooksFetching: false })

const getEndpointRequest = (state) => state.merge({ webhooksFetching: true })
const getEndpointSuccess = (state, { payload: data }) =>
  state.merge({ webhooksFetching: false, endpointData: data })
const getEndpointFailure = (state) => state.merge({ webhooksFetching: false })

const resendEventRequest = (state) => state.merge({ webhooksFetching: true })
const resendEventSuccess = (state, { payload: data }) => state.merge({ webhooksFetching: false })
const resendEventFailure = (state) => state.merge({ webhooksFetching: false })

const changeEndpointStatusRequest = (state) => state.merge({ webhooksFetching: true })
const changeEndpointStatusSuccess = (state, { payload: data }) =>
  state.merge({ webhooksFetching: false })
const changeEndpointStatusFailure = (state) => state.merge({ webhooksFetching: false })

const deleteEndpointRequest = (state) => state.merge({ webhooksFetching: true })
const deleteEndpointSuccess = (state, { payload: data }) => state.merge({ webhooksFetching: false })
const deleteEndpointFailure = (state) => state.merge({ webhooksFetching: false })

const addEndpointRequest = (state) => state.merge({ webhooksFetching: true })
const addEndpointSuccess = (state, { payload }) => state.merge({ webhooksFetching: false })
const addEndpointFailure = (state) => state.merge({ webhooksFetching: false })

const addTypesRequest = (state) => state.merge({ webhooksFetching: true })
const addTypesSuccess = (state, { payload: data }) => state.merge({ webhooksFetching: false })
const addTypesFailure = (state) => state.merge({ webhooksFetching: false })

export const publicApiSetProp = (state, { key, value }) => {
  const obj = {}
  if (["filtersEvents"]?.includes(key)) {
    if (key === "filtersEvents") obj.filtersLastUpd = new Date().getTime()
    obj[key] = { ...state?.[key], ...value }
  } else {
    obj[key] = value
  }
  return state.merge(obj)
}

const requestResultReset = (state) => {
  return state.merge({
    requestResult: null
  })
}

// Bump when the shape of the saved `{ version, filtersEvents }` payload changes.
export const PUBLIC_API_EVENTS_PREFERENCES_VERSION = 1

const applyPreferences = (state, { payload }) => {
  const preference = payload?.["public-api-events"]?.data
  if (!preference || preference.version !== PUBLIC_API_EVENTS_PREFERENCES_VERSION) return state
  if (!preference.filtersEvents) return state

  return state.merge({ filtersEvents: preference.filtersEvents })
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_API_KEYS_REQUEST]: getApiKeysRequest,
  [Types.GET_API_KEYS_SUCCESS]: getApiKeysSuccess,
  [Types.GET_API_KEYS_FAILURE]: getApiKeysFailure,

  [Types.GET_EVENTS_REQUEST]: getEventsRequest,
  [Types.GET_EVENTS_SUCCESS]: getEventsSuccess,
  [Types.GET_EVENTS_FAILURE]: getEventsFailure,

  [Types.GET_EVENT_REQUEST]: getEventRequest,
  [Types.GET_EVENT_SUCCESS]: getEventSuccess,
  [Types.GET_EVENT_FAILURE]: getEventFailure,

  [Types.RESEND_EVENT_REQUEST]: resendEventRequest,
  [Types.RESEND_EVENT_SUCCESS]: resendEventSuccess,
  [Types.RESEND_EVENT_FAILURE]: resendEventFailure,

  [Types.GENERATE_API_KEY_REQUEST]: generateApiKeyRequest,
  [Types.GENERATE_API_KEY_SUCCESS]: generateApiKeySuccess,
  [Types.GENERATE_API_KEY_FAILURE]: generateApiKeyFailure,

  [Types.REGENERATE_API_KEY_REQUEST]: regenerateApiKeyRequest,
  [Types.REGENERATE_API_KEY_SUCCESS]: regenerateApiKeySuccess,
  [Types.REGENERATE_API_KEY_FAILURE]: regenerateApiKeyFailure,

  [Types.GET_ENDPOINTS_REQUEST]: getEndpointsRequest,
  [Types.GET_ENDPOINTS_SUCCESS]: getEndpointsSuccess,
  [Types.GET_ENDPOINTS_FAILURE]: getEndpointsFailure,

  [Types.GET_ENDPOINT_REQUEST]: getEndpointRequest,
  [Types.GET_ENDPOINT_SUCCESS]: getEndpointSuccess,
  [Types.GET_ENDPOINT_FAILURE]: getEndpointFailure,

  [Types.CHANGE_ENDPOINT_STATUS_REQUEST]: changeEndpointStatusRequest,
  [Types.CHANGE_ENDPOINT_STATUS_SUCCESS]: changeEndpointStatusSuccess,
  [Types.CHANGE_ENDPOINT_STATUS_FAILURE]: changeEndpointStatusFailure,

  [Types.DELETE_ENDPOINT_REQUEST]: deleteEndpointRequest,
  [Types.DELETE_ENDPOINT_SUCCESS]: deleteEndpointSuccess,
  [Types.DELETE_ENDPOINT_FAILURE]: deleteEndpointFailure,

  [Types.ADD_ENDPOINT_REQUEST]: addEndpointRequest,
  [Types.ADD_ENDPOINT_SUCCESS]: addEndpointSuccess,
  [Types.ADD_ENDPOINT_FAILURE]: addEndpointFailure,

  [Types.ADD_TYPES_REQUEST]: addTypesRequest,
  [Types.ADD_TYPES_SUCCESS]: addTypesSuccess,
  [Types.ADD_TYPES_FAILURE]: addTypesFailure,

  [Types.PUBLIC_API_SET_PROP]: publicApiSetProp,

  [Types.REQUEST_RESULT_RESET]: requestResultReset,

  [preferencesSuccess.type]: applyPreferences
})
